export const AUTH_QUERY_KEY = "auth";
export const USER_EXISTS_IN_DB_QUERY_KEY = "userExistsInDb";
